import React from 'react';
import * as Sentry from '@sentry/react';
import { LineIcon } from './PreGame';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactElement;
}

const DefaultFallback: React.FC = () => (
  <div className="flex flex-col items-center justify-center p-8 text-center">
    <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-base-200 text-primary">
      <LineIcon name="exclamation" className="w-7 h-7" />
    </span>
    <h2 className="font-comic text-2xl mb-2">Something went wrong</h2>
    <p className="text-base-content/70 mb-4">
      We&apos;ve been notified and are working on it.
    </p>
    <button
      onClick={() => window.location.reload()}
      className="btn btn-primary"
    >
      Refresh page
    </button>
  </div>
);

export const SentryErrorBoundary: React.FC<Props> = ({ children, fallback }) => {
  return (
    <Sentry.ErrorBoundary fallback={fallback ?? <DefaultFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
